// extracted by mini-css-extract-plugin
module.exports = {"widget":"style_widget__3sIit","container":"style_container__2w8VX","section":"style_section__3fbFp","widgetText":"style_widgetText__3Tf2_","widgetIcon":"style_widgetIcon__4KMqN"};